import { ChangeEvent, useState, useCallback } from "react";
import { determineCardName, determinePostalPlaceholder } from "../utilities";
import moment from "moment";
import { getCountry } from "../types/PartialProduct";

export type ProductState = {
  postalPlaceholder: string;
  cardIcon?: string;
  email?: string;
  cardNumber?: string;
  billingName?: string;
  expiration?: Date;
  cvc?: string;
  country?: string;
  postalCode?: string;
  processing: boolean;
  hasPostal: boolean;
};

export default function useProductState(alpha2: string, hasPostal: boolean) {
  const [state, setState] = useState<ProductState>({
    postalPlaceholder: determinePostalPlaceholder(alpha2),
    processing: false,
    hasPostal: hasPostal,
    country: alpha2,
  });
  const [country, setCountry] = useState<string>(alpha2);

  function handleCardNumberInput(event: ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    const cardIcon = determineCardName(value);
    setState({
      ...state,
      cardIcon: cardIcon,
      cardNumber: value,
    });
  }

  function handleCountrySelected(
    value: string | undefined
  ) {
    if (!value) return;

    getCountry(value).then((hasPostal) => {
      const postalPlaceholder = determinePostalPlaceholder(value);

      setCountry(value);
      setState({
        ...state,
        postalPlaceholder: postalPlaceholder,
        hasPostal: hasPostal,
      });
    });
  }

  function handleEmailChange(
    email: string
  ) {
    console.log("changing");
    setState({
      ...state,
      email: email,
    });
  }

  function handleCardNameChange(
    event: ChangeEvent<HTMLInputElement>
  ) {
    const value = event.target.value;

    setState({
      ...state,
      billingName: value,
    });
  }

  function handleExpirationChange(
    event: ChangeEvent<HTMLInputElement>
  ) {
    const value = event.target.value;

    const date = moment(value, "MM/YY").toDate();

    setState({
      ...state,
      expiration: date,
    });
  }

  function handleCVCChange(
    event: ChangeEvent<HTMLInputElement>
  ) {
    const value = event.target.value;

    setState({
      ...state,
      cvc: value,
    });
  }

  function handlePostalChange(
    event: ChangeEvent<HTMLInputElement>
  ) {
    const value = event.target.value;

    setState({
      ...state,
      postalCode: value,
    });
  }

  function toggleProcessing() {
    setState({
      ...state,
      processing: !state.processing,
    });
  }

  return {
    country,
    state,
    toggleProcessing,
    handleCardNameChange,
    handlePostalChange,
    handleCardNumberInput,
    handleCountrySelected,
    handleEmailChange,
    handleExpirationChange,
    handleCVCChange,
  };
}
